import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { FileText, Download, Printer, Share2, Calendar } from 'lucide-react';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { Separator } from '../components/Separator';
export function DailyBrief() {
  const handleExport = (format: string) => {
    toast.success(`Brief diekspor sebagai ${format}`, {
      description: 'File telah diunduh ke perangkat Anda.'
    });
  };
  const handleShare = () => {
    toast.info('Tautan dibagikan', {
      description: 'Tautan aman telah disalin ke clipboard.'
    });
  };
  const today = new Intl.DateTimeFormat('id-ID', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date());
  return <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-6" data-id="element-1618">
      <PageHeader group="Intelijen Presiden" title="Daily Presidential Brief" description={today} icon={Calendar} extraActions={<div className="flex gap-2" data-id="element-1620">
            <Button variant="outline" size="sm" className="px-2 sm:px-3" onClick={() => handleExport('PDF')} data-id="element-1621">
              <Download className="size-4 sm:mr-2" data-id="element-1622" />{' '}
              <span className="hidden sm:inline" data-id="element-1623">PDF</span>
            </Button>
            <Button variant="outline" size="sm" className="px-2 sm:px-3" onClick={() => handleExport('DOCX')} data-id="element-1624">
              <Printer className="size-4 sm:mr-2" data-id="element-1625" />{' '}
              <span className="hidden sm:inline" data-id="element-1626">Cetak</span>
            </Button>
            <Button variant="default" size="sm" className="px-2 sm:px-3" onClick={handleShare} data-id="element-1627">
              <Share2 className="size-4 sm:mr-2" data-id="element-1628" />{' '}
              <span className="hidden sm:inline" data-id="element-1629">Bagikan</span>
            </Button>
          </div>} data-id="element-1619" />

      <Card className="bg-card border-border/50" data-id="element-1630">
        <CardHeader className="border-b border-border/50 bg-muted/10" data-id="element-1631">
          <div className="flex justify-between items-center" data-id="element-1632">
            <CardTitle className="font-mono text-sm uppercase tracking-wider text-foreground flex items-center gap-2" data-id="element-1633">
              <FileText className="size-4 text-primary" data-id="element-1634" />
              Ringkasan Eksekutif (24 Jam Terakhir)
            </CardTitle>
            <span className="font-mono text-[10px] bg-red-500/10 text-red-500 px-2 py-1 rounded border border-red-500/20" data-id="element-1635">
              KLASIFIKASI: RAHASIA
            </span>
          </div>
        </CardHeader>
        <CardContent className="p-8 space-y-8" data-id="element-1636">
          <section data-id="element-1637">
            <h3 className="font-bold text-lg text-foreground mb-3 border-l-4 border-primary pl-3" data-id="element-1638">
              1. Situasi Umum & Sentimen
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-1639">
              Secara umum, sentimen publik terhadap pemerintah berada pada level{' '}
              <strong className="text-amber-500" data-id="element-1640">WASPADA (Skor: 62/100)</strong>
              . Terdapat penurunan sentimen positif sebesar 4% dibandingkan hari
              sebelumnya, didorong oleh eskalasi isu ekonomi di wilayah Jawa dan
              Sumatera. Volume percakapan terkait kebijakan pemerintah mencapai
              450.000 sebutan dalam 24 jam terakhir.
            </p>
          </section>

          <Separator className="bg-border/50" data-id="element-1641" />

          <section data-id="element-1642">
            <h3 className="font-bold text-lg text-foreground mb-3 border-l-4 border-red-500 pl-3" data-id="element-1643">
              2. Isu Kritis & Ancaman (Prioritas Tinggi)
            </h3>
            <ul className="space-y-4" data-id="element-1644">
              <li className="bg-red-500/5 border border-red-500/20 p-4 rounded-md" data-id="element-1645">
                <h4 className="font-bold text-red-500 text-sm mb-1" data-id="element-1646">
                  A. Deepfake Audio Presiden
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-1647">
                  Beredar 45 video di TikTok yang menggunakan AI voice cloning
                  suara Presiden RI, menyebarkan narasi palsu terkait pembatalan
                  bansos. Potensi viral sangat tinggi. <br data-id="element-1648" />
                  <strong data-id="element-1649">Rekomendasi:</strong> Kementerian Komdigi segera
                  melakukan takedown dan rilis klarifikasi resmi dalam 4 jam.
                </p>
              </li>
              <li className="bg-amber-500/5 border border-amber-500/20 p-4 rounded-md" data-id="element-1650">
                <h4 className="font-bold text-amber-500 text-sm mb-1" data-id="element-1651">
                  B. Operasi Tagar Terkoordinasi (#TolakKebijakanX)
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-1652">
                  Terdeteksi 1.247 akun bot yang secara sistematis menaikkan
                  tagar penolakan kebijakan di platform X sejak pukul 02:00 WIB.
                  <br data-id="element-1653" />
                  <strong data-id="element-1654">Rekomendasi:</strong> Tim Komunikasi merilis
                  kontra-narasi yang berfokus pada manfaat kebijakan bagi
                  masyarakat bawah.
                </p>
              </li>
            </ul>
          </section>

          <Separator className="bg-border/50" data-id="element-1655" />

          <section data-id="element-1656">
            <h3 className="font-bold text-lg text-foreground mb-3 border-l-4 border-blue-500 pl-3" data-id="element-1657">
              3. Pemetaan Wilayah (Hotspot)
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-1658">
              <div className="bg-muted/20 p-3 rounded border border-border/50" data-id="element-1659">
                <span className="font-mono text-[10px] text-red-500 font-bold block mb-1" data-id="element-1660">
                  JAWA (TENSION: 88 - KRITIS)
                </span>
                <p className="text-xs text-muted-foreground" data-id="element-1661">
                  Isu dominan: Harga beras melambung, kelangkaan pupuk subsidi,
                  dan hoaks bansos. Konsentrasi di Jawa Tengah dan Jawa Barat.
                </p>
              </div>
              <div className="bg-muted/20 p-3 rounded border border-border/50" data-id="element-1662">
                <span className="font-mono text-[10px] text-amber-500 font-bold block mb-1" data-id="element-1663">
                  PAPUA (TENSION: 72 - WASPADA)
                </span>
                <p className="text-xs text-muted-foreground" data-id="element-1664">
                  Isu dominan: Keamanan menjelang kunjungan kerja Presiden.
                  Terdapat indikasi mobilisasi opini penolakan di grup Telegram
                  tertutup.
                </p>
              </div>
            </div>
          </section>

          <Separator className="bg-border/50" data-id="element-1665" />

          <section data-id="element-1666">
            <h3 className="font-bold text-lg text-foreground mb-3 border-l-4 border-emerald-500 pl-3" data-id="element-1667">
              4. Keputusan yang Diperlukan Hari Ini
            </h3>
            <div className="space-y-2" data-id="element-1668">
              <div className="flex items-start gap-3 p-2 hover:bg-muted/10 rounded" data-id="element-1669">
                <input type="checkbox" className="mt-1" data-id="element-1670" />
                <div data-id="element-1671">
                  <p className="text-sm font-medium" data-id="element-1672">
                    Persetujuan Takedown Deepfake
                  </p>
                  <p className="text-xs text-muted-foreground" data-id="element-1673">
                    Memberikan otorisasi kepada Komdigi untuk berkoordinasi
                    dengan platform.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-2 hover:bg-muted/10 rounded" data-id="element-1674">
                <input type="checkbox" className="mt-1" data-id="element-1675" />
                <div data-id="element-1676">
                  <p className="text-sm font-medium" data-id="element-1677">
                    Instruksi Rilis Data Bansos
                  </p>
                  <p className="text-xs text-muted-foreground" data-id="element-1678">
                    Menginstruksikan Kemensos untuk segera mempublikasikan data
                    realisasi bansos untuk meredam hoaks.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </CardContent>
      </Card>
    </div>;
}